import React from "react"
import { IntlProvider } from "react-intl"

import messages_en from "../../assets/data/locales/en.json"
import messages_tr from "../../assets/data/locales/tr.json"

const menu_messages = {
  en: messages_en,
  tr: messages_tr
}

const Context = React.createContext()

class IntlProviderWrapper extends React.Component {
  state = {
    locale: localStorage.getItem("uiLang") ? localStorage.getItem("uiLang") : "en",
    messages: menu_messages[localStorage.getItem("uiLang") ? localStorage.getItem("uiLang") : "en"]
  }

  render() {
    const { children } = this.props
    const { 
      // locale, 
      messages 
    } = this.state
    return (
      <Context.Provider
        value={{
          state: this.state,
          switchLanguage: language => {
            this.setState({
              locale: language,
              messages: menu_messages[language]
            })

            localStorage.setItem("uiLang", language)

            window.location.reload()
          }
        }}
      >
        <IntlProvider
          key={localStorage.getItem("uiLang") ? localStorage.getItem("uiLang") : "en"}
          locale={localStorage.getItem("uiLang") ? localStorage.getItem("uiLang") : "en"}
          messages={messages}
          defaultLocale={localStorage.getItem("uiLang") ? localStorage.getItem("uiLang") : "en"}
        >
          {children}
        </IntlProvider>
      </Context.Provider>
    )
  }
}

export { IntlProviderWrapper, Context as IntlContext }
